import { useEffect } from 'react';
import { ChevronDown } from 'react-feather';
import i18n from '@src/utility/I18n';

// ** Third Party Components
import { UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const LangDropdown = () => {
    const { t } = useTranslation();

    // Function to determine the display language based on the stored value or i18n's current language
    const getCulture = () => {
        const currentLang = i18n.language.slice(0, 2); // Use i18n's current language
        switch (currentLang) {
            case 'fr':
                return 'Français';
            case 'en':
                return 'English';
            case 'de':
                return 'Deutsch';
            case 'it':
                return 'Italiano';
            case 'pt':
                return 'Português';
            default:
                return 'English';
        }
    };

    const handleLangUpdate = (culture) => {
        i18n.changeLanguage(culture);
        window.localStorage.setItem('language', culture);
    };

    // Effect hook to set i18n language based on localStorage or default to 'fr'
    useEffect(() => {
        const storedLang = window.localStorage.getItem('language') || 'fr';
        i18n.changeLanguage(storedLang);
    }, []);

    return (
        <UncontrolledDropdown href="/" tag="li" className="dropdown-language nav-item">
            <DropdownToggle
                href="/"
                tag="a"
                className="nav-link d-flex align-items-center"
                onClick={(e) => e.preventDefault()}
            >
                <span className="selected-language font-weight-normal">{getCulture()}</span>
                <ChevronDown className="ml-50" />
            </DropdownToggle>
            <DropdownMenu className="mt-0">
                {['fr', 'en', 'it', 'de', 'pt'].map((lang) => (
                    <DropdownItem key={lang} tag="a" onClick={() => handleLangUpdate(lang)}>
                        <span>{t(lang)}</span>
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </UncontrolledDropdown>
    );
};

export default LangDropdown;
